/* eslint-disable camelcase */
import * as _braze from '@braze/web-sdk'
import { getUserExternalId, isAllowedIAMPathFromUrl } from './braze.util'
import { removeNullishProperty, getEnv } from './common'

class Braze {
  constructor() {
    this.braze = _braze
  }
  initialize() {
    const isProd = getEnv() === 'prd'
    const endpoint = isProd ? 'sdk.iad-06.braze.com' : 'sdk.iad-07.braze.com'
    this.braze.initialize(process.env.VUE_APP_BRAZE_API_KEY, {
      baseUrl: endpoint,
      enableLogging: !isProd,
      allowUserSuppliedJavascript: true,
      // serviceWorkerLocation: '/service-worker.js', // push notification 사용 시 주석 해제
    })

    // *두 트리거(자동, 수동)를 모두 활성화 하면 IAM(In App Message)가 중복 노출 될 수 있음
    // this.braze.automaticallyShowInAppMessages() // IAM 자동트리거 활성화
    this.subscribeToInAppMessage() // IAM 수동트리거 활성화 (기획상 특정 라우트에서만 노출해야하므로 수동 트리거 활성화)

    this.connectUser(getUserExternalId())
  }
  subscribeToInAppMessage() {
    this.braze.subscribeToInAppMessage((inAppMessage) => {
      // 제어 그룹인 경우 showInAppMessage를 호출해도 메시지는 노출하지 않음
      // (제어그룹에 대한 로그는 남기기 위해 showInAppMessage 호출)
      if (inAppMessage?.isControl) {
        return this.braze.showInAppMessage(inAppMessage)
      }
      this.handleDeferredInAppMessage(inAppMessage)
    })
  }

  handleDeferredInAppMessage(inAppMessage) {
    if (!inAppMessage) return
    if (isAllowedIAMPathFromUrl(window.location.href)) {
      this.braze.showInAppMessage(inAppMessage)
    } else {
      this.braze.deferInAppMessage(inAppMessage)
    }
  }

  /**
   * 지연시켜둔 브레이즈의 in-app message가 존재하는 경우 노출
   */
  showDeferredInAppMessage() {
    const deferredMessage = this.deferredMessage()
    if (deferredMessage) {
      this.braze.showInAppMessage(deferredMessage)
    }
  }
  changeUser(externalId) {
    if (
      !externalId ||
      externalId === 'none' ||
      externalId === this.getUserId()
    ) {
      return
    }
    this.braze.changeUser(externalId)
  }
  openSession() {
    this.braze.openSession()
  }
  getUserId() {
    return this.braze.getUser().getUserId()
  }
  connectUser(externalId) {
    if (externalId) {
      this.changeUser(externalId)
    }
    this.openSession()
  }
  purchase(eventProperties) {
    const { product_id, price, currency } = eventProperties
    this.braze.logPurchase(product_id, price, currency, 1, {
      ...eventProperties,
    })
  }

  /**
   * 플레이어로부터 발생한 브레이즈 이벤트의 name와 property를 모두 전달받아 브레이즈로 바로 전송
   * @param {Object} param0
   * @param {string} param0.eventType - 브레이즈 이벤트 타입 (event name)
   * @param {Object} param0.data - 브레이즈 이벤트에 전달할 데이터 (property)
   * @returns
   */
  playerCustomEvent({ eventType, data }) {
    if (!eventType) {
      console.warn('Braze playerCustomEvent: eventType is required')
      return
    }
    const eventProperties = removeNullishProperty(data || {})
    this.braze.logCustomEvent(eventType, {
      ...eventProperties,
    })
  }
  deferredMessage() {
    return this.braze?.getDeferredInAppMessage()
  }
  showInAppMessage(inAppMessage) {
    this.braze?.showInAppMessage(inAppMessage)
  }
  // 이건 브레이즈 대시보드에서 노코드로 만든 In-App Message를 통해 소프트 푸시 알림을 보낼 때는 사용 안함
  setBrazeWebPush() {
    if (!this.braze) return

    // 브라우저가 web push 지원하는지 체크
    if (!this.braze.isPushSupported()) {
      console.warn('Braze Web Push 미지원 브라우저')
      return
    }

    // 이미 차단된 경우
    if (this.braze.isPushBlocked && this.braze.isPushBlocked()) {
      console.warn('알림이 차단되어 있습니다. 설정에서 알림 허용해주세요.')
      return
    }

    // 이미 푸시 권한이 있는 경우 (브라우저의 알림 허용 상태) -> braze에 사용자 연결
    if (this.braze.isPushPermissionGranted()) {
      this.braze.requestPushPermission()
      return
    }

    try {
      this.braze.requestPushPermission()
    } catch (error) {
      console.warn('Braze Web Push 권한 요청 거절/실패', error)
    }
  }
}

const braze = new Braze()
export default braze
